module.exports = __webpack_public_path__ + "static/img/middle.148a067.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product/pc/top/middle.png
// module id = 3jei
// module chunks = 1